<template>
  <ion-page>
    <master-layout @refreshPage="reRender" pageTitle="نقشه مشتریان">
      <Loading v-if="!loaded"></Loading>
      <div v-if="loaded">
        <IonCardContent class="p-2">
          <label>فیلتر مشتریان براساس منطقه</label>
          <select autocomplete="off" class="form-control" v-model="selected_area">
            <option v-for="(a , index) in areas" :key="index" :value="a._id">{{a.title}}</option>
          </select>
        </IonCardContent>
        <div id="map_div2"  ref="map_div2">
          <div id="map"></div>
        </div>
        <div v-if="error">
          <div class="alert alert-danger">{{error}}</div>
        </div>
      </div>

    </master-layout>
  </ion-page>
</template>

<script>
import L from "leaflet";
require('leaflet.locatecontrol');
import {mapActions} from "vuex";
import {IonPage,IonCardContent} from '@ionic/vue';
import Loading from "../../components/Loading";


// import {getFormData} from '@/shared/helper'

export default {
  name: "customersMap",
  components: {
    Loading,
    IonPage,IonCardContent
  },
  data()
  {
    return {
      customers : [],
      loaded : false,
      error : null,
      map : null,
      map_html : '',
      lat : '',
      lng : '',
      selected_area : null,
      areas : [],
      set_latlng : null,
    }
  },
  async mounted()
  {
    const result = await this.getAllCustomerArea();
    if (result)
    {
      this.areas = result.areas;
    }
    window.page=this;
    this.init();
  },
  methods: {
    ...mapActions('customer',{
      getAllCustomerForMap : 'getAllCustomerForMap',
      getAllCustomerArea : 'getAllCustomerArea'
    }),
    async init()
    {
      const self = this;
      this.loaded = false;
      // const customers = await
      const result = await this.getAllCustomerForMap( this.selected_area);
      if (result)
      {
        const customers = result.customers;
        for (let i = 0; i < customers.length; i++)
        {
          if (customers[i].location && customers[i].location.coordinates && customers[i].location.coordinates[0] && customers[i].location.coordinates[1])
          {
            if (!this.set_latlng)
            {
              this.lat = customers[i].location.coordinates[1];
              this.lng = customers[i].location.coordinates[0];
              this.set_latlng = true;
              break;
            }
          }
        }
        this.loaded = true;
        setTimeout(function (){
          self.initMap();
          for (let i = 0; i < customers.length; i++)
          {
            if (customers[i].location && customers[i].location.coordinates && customers[i].location.coordinates[0] && customers[i].location.coordinates[1])
            {
              if (!this.set_latlng)
              {
                this.lat = customers[i].location.coordinates[1];
                this.lag = customers[i].location.coordinates[0];
              }


              self.placeMarker({
                latlng: {
                  lat:customers[i].location.coordinates[1],
                  lng:customers[i].location.coordinates[0],
                }
              },customers[i]._id,customers[i].fullname);
            }
          }
        },1000);
      }
      else
      {
        this.error = 'خطا در برقراری ارتباط';
      }
      this.loaded = true;
    },
    initMap()
    {
      this.map_html = this.$refs['map_div2'];
      this.map_html.innerHTML = '<div id="map" style="height: 380px"></div>';
      // $('#map_div2').html('<div id="map" style="height: 380px;direction: ltr;"></div>');
      var lat=this.lat , lng= this.lng;
      var zoom=10;
      var osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          osmAttrib = '&copy; <a href="https://carencar.com">کارن کار</a>',
          osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib});
      this.map = L.map('map',{ zoomControl: true, dragging: true, boxZoom: true, scrollWheelZoom: true }).setView([lat,lng], zoom).addLayer(osm);
      L.control.locate({
        drawCircle: true, // controls whether a circle is drawn that shows the uncertainty about the location
        setView: true, // automatically sets the map view to the user's location, enabled if follow is true
        follow:true,
        flyTo:true,
        keepCurrentZoomLevel: false, // keep the current map zoom level when displaying the user's location. (if false, use maxZoom)
        circlePadding: [0, 0], // padding around accuracy circle, value is passed to setBounds
        locateOptions: {
          maxZoom: 15
        },
        strings: {
          title: "نمایش موقعیت فعلی", // title of the locate control
          popup: "موقعیت فعلی شما", // text to appear if user clicks on circle
          outsideMapBoundsMsg: "بنظر میاد شما در خارج از این کره خاکی هستید" // default message for onLocationOutsideMapBounds
        }
      }).addTo(this.map);
      // L.Control.geocoder().addTo(this.map);


    },
    placeMarker(e,id,fullname)
    {
      const self = this;
      const iconUrl = '/assets/img/order-marker.png';

      const markerIcon = new L.Icon({
        iconUrl: iconUrl,
        iconSize:     [30, 46],
      });
      this.markerHolder = new L.marker(e.latlng,{icon:markerIcon})
      this.markerHolder.addTo(this.map);
      this.lat = e.latlng.lat;
      this.lng = e.latlng.lng;
      this.markerHolder.on('click', function ()
      {
        const id2 = "'"+id+"'";
        L.popup()
            .setLatLng(e.latlng)
            .setContent('<div class="center"> <b style="margin-bottom: 5px;display: block;">'+fullname+'</b><div><button onclick="window.page.showCustomerInfo('+id2+')" class="btn btn-info">مشاهده اطلاعات</button></div></div>')
            .openOn(self.map);
      })

    },
    showCustomerInfo(id)
    {
      this.$router.push({path : '/customer/Edit/'+id})
    },
    reRender()
    {
      this.init();
    }

  },watch : {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('customermap') >= 0 && oldUrl.toLowerCase().indexOf('customermap') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
    selected_area : {
      handler()
      {
        this.init();
      },deep : true
    }
  }
}

</script>

<style scoped>
/*#map{*/
/*  height: 100px;*/
/*  direction: ltr;*/
/*}*/
.mb-1
{
  display: block;
  margin-bottom: 5px;
}
.p-2
{
  padding: 8px;
}

</style>